import { sheetScope } from "../utils/props";

export const interactionScope = /*           */ sheetScope.scope("interaction");
